import {
  Search,
  Download,
  Upload,
  CloudUpload,
  X,
  Stethoscope,
  Activity,
  User,
  MessageSquare,
  HeartHandshake,
  ClipboardList,
  Briefcase,
  Menu,
  LogOut,
  ChevronDown,
  Bell,
  Settings,
  Eye,
  EyeOff,
  Edit,
  Trash2,
  ArrowUp,
  ArrowDown,
  ArrowUpDown,
  LayoutDashboard,
  Users,
  FileSignature,
  CreditCard,
  ClipboardCheck,
  FileText,
  FileBadge,
  PieChart,
  Files,
  PenTool,
  ChevronLeft,
  ChevronRight,
  LogIn,
  Clock,
  Coffee,
  PlayCircle,
  Check,
  Pen,
  Lock,
  Plus,
  Minus,
  Printer,
  Calendar,
  AlertCircle,
  CheckCircle,
  Info,
  IdCard,
  ArrowRight,
  Map,
  FileCheck,
  FileSpreadsheet,
  ArrowLeft,
  History,
  UserX,
  UserCheck,
  UserPlus,
  Mail,
  Phone,
  MapPin,
  UserPen,
  Loader2,
  Shield,
  ShieldCheck,
  LifeBuoy,
  Heart,
  MoreVertical,
  Pill,
  FolderOpen,
  Folder,
  Paperclip,
  Receipt,
  RefreshCw,
  XCircle,
  StickyNote,
  Building2,
  ListChecks,
  Send,
  Library,
  Home,
  Utensils,
  Brain,
  HeartPulse,
  Target,
  GraduationCap,
  ExternalLink,
  Archive,
  ArchiveRestore,
} from "lucide-react";

// Employee Table Icons
export const SearchIcon = (props) => <Search {...props} />;
export const DownloadIcon = (props) => <Download {...props} />;
export const CloseIcon = (props) => <X {...props} />;
export const UserXIcon = (props) => <UserX {...props} />;
export const UserCheckIcon = (props) => <UserCheck {...props} />;
export const UserPlusIcon = (props) => <UserPlus {...props} />;
export const UploadIcon = (props) => <Upload {...props} />;
export const CloudUploadIcon = (props) => <CloudUpload {...props} />;
export const MailIcon = (props) => <Mail {...props} />;
export const PhoneIcon = (props) => <Phone {...props} />;
export const MapPinIcon = (props) => <MapPin {...props} />;
export const UserEditIcon = (props) => <UserPen {...props} />;

// Dashboard Icons
export const NurseIcon = (props) => <Stethoscope {...props} />;
export const RunningIcon = (props) => <Activity {...props} />;
export const DoctorIcon = (props) => <User {...props} />;
export const CommentsIcon = (props) => <MessageSquare {...props} />;
export const HelpingIcon = (props) => <HeartHandshake {...props} />;
export const MedicalNotesIcon = (props) => <ClipboardList {...props} />;
export const BriefcaseIcon = (props) => <Briefcase {...props} />;

// Navbar Icons
export const MenuIcon = (props) => <Menu {...props} />;
export const LogoutIcon = (props) => <LogOut {...props} />;
export const ChevronDownIcon = (props) => <ChevronDown {...props} />;
export const BellIcon = (props) => <Bell {...props} />;
export const SettingsIcon = (props) => <Settings {...props} />;

// Table Icons
export const ViewIcon = (props) => <Eye {...props} />;
export const ViewOffIcon = (props) => <EyeOff {...props} />;
export const EditIcon = (props) => <Edit {...props} />;
export const DeleteIcon = (props) => <Trash2 {...props} />;
export const MoreVerticalIcon = (props) => <MoreVertical {...props} />;
export const SortIcon = (props) => <ArrowUpDown {...props} />;
export const SortUpIcon = (props) => <ArrowUp {...props} />;
export const SortDownIcon = (props) => <ArrowDown {...props} />;
export const ArrowRightIcon = (props) => <ArrowRight {...props} />;
export const ArrowLeftIcon = (props) => <ArrowLeft {...props} />;
export const PrintIcon = (props) => <Printer {...props} />;
export const CalendarIcon = (props) => <Calendar {...props} />;
export const AlertCircleIcon = (props) => <AlertCircle {...props} />;
export const CheckCircleIcon = (props) => <CheckCircle {...props} />;
export const IdCardIcon = (props) => <IdCard {...props} />;
export const HistoryIcon = (props) => <History {...props} />;

// General Forms Icons
export const MapIcon = (props) => <Map {...props} />;
export const FileCheckIcon = (props) => <FileCheck {...props} />;
export const FileSpreadsheetIcon = (props) => <FileSpreadsheet {...props} />;

// Sidebar Icons
export const DashboardIcon = (props) => <LayoutDashboard {...props} />;
export const UsersIcon = (props) => <Users {...props} />;
export const ApplicationsIcon = (props) => <FileSignature {...props} />;
export const PatientsIcon = (props) => <Heart {...props} />;
export const PayrollIcon = (props) => <CreditCard {...props} />;
export const EvaluationIcon = (props) => <ClipboardCheck {...props} />;
export const DocumentsIcon = (props) => <FileText {...props} />;
export const InvoiceIcon = (props) => <FileBadge {...props} />;
export const ReceiptIcon = (props) => <Receipt {...props} />;
export const ReportsIcon = (props) => <PieChart {...props} />;
export const FormsIcon = (props) => <Files {...props} />;
export const SurveyorIcon = (props) => <PenTool {...props} />;
export const ChevronLeftIcon = (props) => <ChevronLeft {...props} />;
export const ChevronRightIcon = (props) => <ChevronRight {...props} />;
export const LoginIcon = (props) => <LogIn {...props} />;
export const ClockIcon = (props) => <Clock {...props} />;
export const CoffeeIcon = (props) => <Coffee {...props} />;
export const PlayIcon = (props) => <PlayCircle {...props} />;
export const CheckIcon = (props) => <Check {...props} />;
export const PenIcon = (props) => <Pen {...props} />;
export const LockIcon = (props) => <Lock {...props} />;
export const PlusIcon = (props) => <Plus {...props} />;
export const MinusIcon = (props) => <Minus {...props} />;
export const LogOutIcon = (props) => <LogOut {...props} />;
export const UserIcon = (props) => <User {...props} />;
export const SpinnerIcon = (props) => <Loader2 {...props} />;
export const ShieldIcon = (props) => <Shield {...props} />;
export const ShieldCheckIcon = (props) => <ShieldCheck {...props} />;
export const SupportIcon = (props) => <LifeBuoy {...props} />;
export const InfoIcon = (props) => <Info {...props} />;
export const PillIcon = (props) => <Pill {...props} />;
export const FolderIcon = (props) => <Folder {...props} />;
export const FolderOpenIcon = (props) => <FolderOpen {...props} />;
export const PaperclipIcon = (props) => <Paperclip {...props} />;
export const RefreshIcon = (props) => <RefreshCw {...props} />;
export const XCircleIcon = (props) => <XCircle {...props} />;
export const NotesIcon = (props) => <StickyNote {...props} />;
export const BuildingIcon = (props) => <Building2 {...props} />;
export const TransactionsIcon = (props) => <ListChecks {...props} />;
export const SendIcon = (props) => <Send {...props} />;
export const LibraryIcon = (props) => <Library {...props} />;
export const HomeIcon = (props) => <Home {...props} />;
export const UtensilsIcon = (props) => <Utensils {...props} />;
export const BrainIcon = (props) => <Brain {...props} />;
export const HeartPulseIcon = (props) => <HeartPulse {...props} />;
export const TargetIcon = (props) => <Target {...props} />;
export const GraduationCapIcon = (props) => <GraduationCap {...props} />;
export const ExternalLinkIcon = (props) => <ExternalLink {...props} />;
export const ArchiveIcon = (props) => <Archive {...props} />;
export const ArchiveRestoreIcon = (props) => <ArchiveRestore {...props} />;
export const InsuranceIcon = (props) => <CreditCard {...props} />;

// FA-named aliases (mapped to lucide-react equivalents)
export const FaFileAlt = (props) => <FileText {...props} />;
export const FaCloudUploadAlt = (props) => <CloudUpload {...props} />;
export const FaEye = (props) => <Eye {...props} />;
export const FaEdit = (props) => <Edit {...props} />;
